import { render, staticRenderFns } from "./ManagementUserTable.vue?vue&type=template&id=bc2ca97a&"
import script from "./ManagementUserTable.vue?vue&type=script&lang=ts&"
export * from "./ManagementUserTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports